import styled from 'styled-components';
import { deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const InputBlock = styled.div`
  width: 100%;
  position: relative;
  margin-top: 40px;
  display: 'inline-block';
  -webkit-border-radius: ${({ emailAddress }) => (emailAddress ? '50%' : 'unset')};
  -moz-border-radius: ${({ emailAddress }) => (emailAddress ? '50%' : 'unset')};
  border-radius: ${({ emailAddress }) => (emailAddress ? '50%' : 'unset')};
  -khtml-border-radius: ${({ emailAddress }) => (emailAddress ? '50%' : 'unset')};
`;

export const StyledInput = styled.input`
  ${FONTS.font16}
  width: 100%;
  min-height: 36px;
  border: none;
  outline: none;
  background: none;
  color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
  border-bottom: ${({ error }) =>
    error ? `1px solid ${COLORS.red}` : `1px solid ${COLORS.mainColor}`};

  &:-webkit-autofill {
    -webkit-text-fill-color: ${({ error }) =>
      error ? COLORS.red : COLORS.mainColor};
  }

  &::placeholder {
    ${FONTS.font16}
    ${FLEX_CONTAINER.FlexRow}
    color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
    ${FONT_FAMILY.FontLight}
  }

  @media only screen and ${deviceMax.mobileL} {
    &::placeholder {
      ${FONTS.font12}
    }
  }
`;

export const PasswordVisibleIcon = styled.img`
  position: absolute;
  right: 0px;
  top: 15px;
  width: 26px;
  cursor: pointer;

  @media only screen and ${deviceMax.desktop} {
    width: 20px;
    right: 0px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 16px;
  }
`;
